import { addMonths, subMonths, startOfDay, endOfDay } from 'date-fns/esm';

export const TODAY = new Date();
export const MOVE_DATE_MIN = subMonths(startOfDay(TODAY), 1);
export const MOVE_DATE_MAX = addMonths(endOfDay(TODAY), 4);

export function convertToISO8601(date) {
  return date.toISOString().substr(0, 10);
}

export const MOVE_DATE_MIN_ISO_8601 = convertToISO8601(MOVE_DATE_MIN);
export const MOVE_DATE_MAX_ISO_8601 = convertToISO8601(MOVE_DATE_MAX);
export const TODAY_ISO_8601 = convertToISO8601(TODAY);

export const DATE_FORMATS = {
  // REF: http://www.iso.org/iso/home/standards/iso8601.htm
  ISO_8601: 'yyyy-MM-dd',
  USA_LONG: 'MM/DD/YYYY',
};
